<template>
  <b-col
    class="d-flex flex-column"
    style="flex: auto; overflow-y:auto;"
    data-cy="confirmacao-container"
  >
    <div class="d-flex flex-row" data-cy="confirmacao-header-row">
      <back-button data-cy="confirmacao-back-button"></back-button>
      <div class="d-flex flex-column mb-4" data-cy="confirmacao-header-info">
        <h4 class="text-primary font-weight-bold" data-cy="confirmacao-title">
          Confira os dados do seu
          {{ type === "exame" ? "exame" : "agendamento" }}
        </h4>
        <small class="font-weight-bold" data-cy="confirmacao-subtitle">
          Confira se todos os dados do agendamento estão corretos e confirme.
        </small>
      </div>
    </div>
    <div
      class="d-flex flex-row h6 mt-3"
      v-if="this.telemedicina"
      data-cy="confirmacao-telemedicina-info"
    >
      <b-card data-cy="confirmacao-telemedicina-card">
        <b-card-title data-cy="confirmacao-telemedicina-title">
          Orientações para Telemedicina
        </b-card-title>
        <b-card-body data-cy="confirmacao-telemedicina-body">
          Clique em agendar para garantir seu horário. Para finalizar a marcação
          será necessário informar o tipo de pagamento.
        </b-card-body>
      </b-card>
    </div>

    <table class="table table-responsive h6 mt-3" data-cy="confirmacao-table">
      <tbody>
        <tr data-cy="confirmacao-row-paciente">
          <td>Paciente</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-paciente"
          >
            {{ selected[5].nome }}
          </td>
        </tr>
        <tr data-cy="confirmacao-row-clinica">
          <td>Clinica</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-clinica"
          >
            {{ selected[2].nome }}
          </td>
        </tr>
        <tr v-if="type !== 'exame'" data-cy="confirmacao-row-especialidade">
          <td>Especialidade</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-especialidade"
          >
            {{ selected[1].nome }}
          </td>
        </tr>
        <tr
          v-if="type === 'exame' || negociacao.procedimento"
          data-cy="confirmacao-row-procedimento"
        >
          <td>Procedimento</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-procedimento"
          >
            {{ type === "exame" ? selected[1].nome : negociacao.procedimento }}
          </td>
        </tr>
        <tr data-cy="confirmacao-row-profissional">
          <td>Profissional</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-profissional"
          >
            {{ formattedProfissionalName }}
          </td>
        </tr>
        <tr data-cy="confirmacao-row-datahora">
          <td>Data e Hora</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-datahora"
          >
            {{ selected[3].nome }}
          </td>
        </tr>

        <tr data-cy="confirmacao-row-convenio">
          <td>Convênio</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-convenio"
          >
            {{ convenio.nome }}
          </td>
        </tr>
        <tr v-if="convenio.particular" data-cy="confirmacao-row-valor">
          <td>Valor</td>
          <td class="font-weight-bold text-primary" data-cy="confirmacao-valor">
            <span v-if="negociacao.valor" data-cy="confirmacao-valor-real">
              R$ {{ negociacao.valor.toFixed(2) }}
            </span>
            <span
              v-if="!negociacao.valor"
              data-cy="confirmacao-valor-nao-informado"
            >
              <em class="text-muted">
                Entre em contato com a clínica para conferir o valor
              </em>
            </span>
          </td>
        </tr>
        <tr data-cy="confirmacao-row-localizacao">
          <td>Localização</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-localizacao"
          >
            {{ clinica | clinicAddress }}
          </td>
        </tr>
        <tr data-cy="confirmacao-row-telefone">
          <td>Telefone de Contato</td>
          <td
            class="font-weight-bold text-primary"
            data-cy="confirmacao-telefone"
          >
            {{ clinicaTelefone }}
          </td>
        </tr>
        <tr v-show="false" data-cy="confirmacao-row-mapa">
          <td colspan="2" class="px-0">
            <img
              style="background-image: url('/static/images/google-map-placeholder.png'); background-size: cover; background-position: center;"
              class="w-100"
              height="300"
            />
          </td>
        </tr>
        <tr data-cy="confirmacao-row-btn">
          <td>
            <router-link
              :to="{
                name: 'finish',
                params: { organizationId: this.$route.params.organizationId },
                query: {
                  ...(this.telemedicina
                    ? { telemedicina: this.telemedicina }
                    : {})
                }
              }"
              class="btn btn-outline-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0"
              data-cy="confirmacao-btn-confirmar"
            >
              Confirmar Agendamento
            </router-link>
          </td>

          <td></td>
        </tr>
      </tbody>
    </table>
  </b-col>
</template>

<script>
import BackButton from "@/components/back-button";
import { generateTo } from "@/core/routerHelper";
import { axiosInstance as Axios } from "@/main";
export default {
  name: "confirmation",
  data() {
    return {
      negociacao: {}
    };
  },
  components: {
    BackButton
  },
  computed: {
    telemedicina() {
      const telemedicina = localStorage.getItem("telemedicina");
      if (telemedicina instanceof Boolean) {
        return telemedicina;
      } else if (telemedicina == "true") {
        return true;
      }
      return false;
    },
    convenio() {
      return this.selected[0];
    },
    selected() {
      return this.$store.getters.get_selected;
    },
    clinicaTelefone() {
      return this.selected[2].telefones
        ? this.selected[2].telefones.join(" | ")
        : "";
    },
    clinica() {
      return this.selected[2];
    },
    type() {
      return this.$store.getters.type;
    },
    formattedProfissionalName() {
      const selectedProfissional = this.selected[4];
      return selectedProfissional.tratamento
        ? `${selectedProfissional.tratamento} ${selectedProfissional.nome}`
        : selectedProfissional.nome;
    }
  },
  async mounted() {
    await this.$store.dispatch("clear_agendamento");
    await this.$store.dispatch("set_to", {
      name: "finish",
      params: { organizationId: this.$route.params.organizationId },
      query: {
        ...(localStorage.getItem("telemedicina")
          ? { telemedicina: localStorage.getItem("telemedicina") }
          : {})
      }
    });
    await this.$store.dispatch("set_from", {
      name: generateTo(6, this.$route),
      params: { organizationId: this.$route.params.organizationId },
      query: {
        ...(localStorage.getItem("telemedicina")
          ? { telemedicina: localStorage.getItem("telemedicina") }
          : {})
      }
    });
    await this.$store.dispatch("set_actual", this.$route.fullPath);
    const agendaId = this.$store.getters.get_selected[3].agendaId;

    this.negociacao = {};
    const isConsultaPresencial = !this.$route.fullPath.includes("exame");

    const negociacao = await Axios.post(
      `${this.$serverHost}agendamentos/negociacao/${agendaId}`,
      {
        agendaId: this.$store.getters.get_selected[3].agendaId
      },
      {
        headers: {
          "X-Organizacao-ID": this.$route.params.organizationId
        },
        params: {
          convenio_id: this.$store.getters.get_selected[0].id,
          especialidade_id: isConsultaPresencial
            ? this.$store.getters.get_selected[1].id
            : null, // Passo 2 -> Especialidade (Somente há escolha de especialidade em consulta presencial)
          clinica_id: this.$store.getters.get_selected[2].id,
          procedimento_id: !isConsultaPresencial
            ? this.$store.getters.get_selected[1].id
            : null // Passo 2 -> Procedimento (na consulta remota e exames)
        }
      }
    );
    this.negociacao = negociacao.data;
  }
};
</script>

<style></style>
